// extracted by mini-css-extract-plugin
module.exports = {"handshakeCard":"handshake_card-module_handshakeCard_343e6","title":"handshake_card-module_title_c5af5","body":"handshake_card-module_body_e874a"};